(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-marital-status', {
                parent: 'entity',
                url: '/type-marital-status',
                data: {
                    authorities: [],
                    pageTitle: 'TypeMaritalStatuses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-marital-status/list/type-marital-status.html',
                        controller: 'TypeMaritalStatusController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Marital Status Type'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS, access);
                }]
            });
    }
})();
